import { normalizeURL } from '../urlHandling/urlNormalizer.js';
export function setCanonicalAndLanguageRelatedMetadata(normalizedURL, detectedLang, languageCodes, season, doc) {
    const url = new URL(normalizedURL);
    const canonicalHref = `${url.origin}${url.pathname}`;
    const canonicalLink = doc.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', canonicalHref);
    doc.head.appendChild(canonicalLink);
    const alternateLanguages = languageCodes.filter((c) => c !== detectedLang);
    alternateLanguages.forEach((lang) => {
        const url = canonicalHref.replace(`/${detectedLang}/`, `/${lang}/`);
        const { normalizedURL } = normalizeURL(url, lang, season, '');
        const link = doc.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('href', normalizedURL);
        link.setAttribute('hreflang', lang);
        doc.head.appendChild(link);
    });
    doc.documentElement.lang = detectedLang;
}
//# sourceMappingURL=canonicalURLHandler.js.map